import { Box, useMediaQuery } from "@mui/material"
import SliderItem from "./components/SliderItem"
import { options as opts, sliderItemSizes, sliderStyles } from "./mockData"
import { getOptions } from "./utils"
import { useMemo } from "react"

const AnimatedSlider = () => {
  const isMobile = useMediaQuery("(max-width: 681px)");
  const isLargeDesktop = useMediaQuery("(max-width: 1679px)");

  const width = useMemo(() => {
    if (isMobile) {
      return sliderItemSizes.xs.width;
    };
    if (isLargeDesktop) {
      return sliderItemSizes.lg.width;
    };
    return sliderItemSizes.xl.width;
  }, [isMobile, isLargeDesktop]);

  const styles = useMemo(() => {
    if (isMobile) {
      return sliderStyles.xs;
    };
    if (isLargeDesktop) {
      return sliderStyles.lg;
    };
    return sliderStyles.xl;
  }, [isMobile, isLargeDesktop]);
  
  return (
    <Box
      sx={{
        position: "absolute",
        display: "flex",
        right: opts.length * -width,
        ...styles
      }}
    >
      {opts.map((opt, index) => (<SliderItem options={getOptions(index, width, isMobile, isLargeDesktop)} key={index} {...opt} />))}
    </Box>
  );
};

export default AnimatedSlider;
